<div class="no-width" fxLayout="column" fxFlexFill fxLayoutAlign="center center">
    <mat-toolbar color='primary'>
        <mat-toolbar-row class='row-center'>
            <div>
                <div fxShow="true" fxHide.lt-md class="title"><img class="main-logo" src="assets/icons/logo_transparent.png">Five Point Strike<img class="main-logo" src="assets/icons/logo_transparent.png"></div>
                <div fxShow="true" fxHide.gt-md class="title-mobile"><img class="main-logo" src="assets/icons/logo_transparent.png">Five Point Strike<img class="main-logo" src="assets/icons/logo_transparent.png"></div>
                <div fxShow="true" fxHide.lt-md class="subtitle">Optimizer, guides, stats, and more for everything fantasy League of Legends</div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-toolbar color='accent'>

        <mat-toolbar-row class='row-center'>
            <button mat-icon-button (click)="sidenav.toggle()" fxShow="true" fxHide.gt-sm>
                <mat-icon>menu</mat-icon>
            </button>

            <div fxShow="true" fxHide.lt-md>
                <nav>
                    <a routerLink="/" routerLinkActive="active" class="header-links">Home</a> | 
                    <a routerLink="/lol-optimizer" routerLinkActive="active" class="header-links">Optimizer</a> | 
                    <a routerLink="/articles" routerLinkActive="active" class="header-links">Guides</a> | 
                    <a routerLink="/about-us" routerLinkActive="active" class="header-links">About Us</a> | 
                    <a routerLink="/terms" routerLinkActive="active" class="header-links">Privacy</a>
                </nav>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-sidenav-container fxFlexFill class="content-background">
        <mat-sidenav #sidenav fxLayout="column" class="sidenav-background">
            <div fxLayout="column">
                <a routerLink="/" (click)="sidenav.toggle()" routerLinkActive="active"
                    class="header-links mobile-links">Home</a>
                <a routerLink="/lol-optimizer" (click)="sidenav.toggle()" routerLinkActive="active"
                    class="header-links mobile-links">Optimizer</a>
                <a routerLink="/articles" (click)="sidenav.toggle()" routerLinkActive="active"
                    class="header-links mobile-links">Guides</a>
                <a routerLink="/about-us" (click)="sidenav.toggle()" routerLinkActive="active"
                    class="header-links mobile-links">About Us</a>
                <a routerLink="/terms" (click)="sidenav.toggle()" routerLinkActive="active"
                    class="header-links mobile-links">Privacy</a>
            </div>
        </mat-sidenav>
        <mat-sidenav-content fxFlexFill class="background">
            <!-- <div fxFlex> -->
            <router-outlet></router-outlet>
            <app-footer></app-footer>
            <!-- </div> -->
        </mat-sidenav-content>
    </mat-sidenav-container>

</div>